import axios from 'axios'
import {apiURL} from "@/api/config";

let fullUrl = `${apiURL}file`;
let fileName = '첨부파일';


export const runFileDown = async (params) => {
    const axiosConfig= {
        method : 'get',
        url : fullUrl,
        data : params,
        params : params,
    };
    try {
        const response = await axios(axiosConfig);
        const url =response.data.Data.Result.List[0].org_url
        const anchor = document.createElement('a');

        anchor.href = url;
        anchor.style.display = 'none';
        anchor.target='_blank'
        anchor.setAttribute('download', fileName);
        document.body.appendChild(anchor);
        anchor.click();
    }catch (e) {
        console.log(e);
    }
};
export const apiFileDownload = (url, name) => {
    fetch(url).then(res =>res.blob()).then( res=>{ 
        let link=document.createElement("a");
        console.log(res)
        link.href= URL.createObjectURL(res);
        link.target = '_blank'
        link.download= name; 
        link.click()   
    });
};
